import script from "./GraphDetailCard.vue?vue&type=script&setup=true&lang=js"
export * from "./GraphDetailCard.vue?vue&type=script&setup=true&lang=js"

import "./GraphDetailCard.vue?vue&type=style&index=0&id=0efab0ac&lang=scss&scoped=true"

import exportComponent from "/Users/cricle/Documents/monetware/code/web/knowledgeGraph-html/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0efab0ac"]])

export default __exports__